// Components==============
import Button from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './NoAuthModal.module.scss';
// =========================

export default function NoAuthModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const translate = useTranslate();

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <div styleName="content">
        <img src="/images/sad-token.svg" alt="no-auth" />
        <h2>{translate('general.licence.licence-ended')}</h2>
        <p>
          {translate('general.licence.description-1')}
          <br />
          <br />
          {translate('general.licence.description-2')}
          <br />
          <br />
          {translate('general.licence.description-3')}
        </p>
        <div styleName="button-wrapper">
          <a
            target="_blank"
            rel="noreferrer"
            href="https://www.studiotast.com/groow"
          >
            <Button color="grey">Groow info</Button>
          </a>
          <a href="mailto:groow@studiotast.com?subject=Nieuwe licentie aanvragen">
            <Button>Nieuwe licentie aanvragen</Button>
          </a>
        </div>
      </div>
    </Modal>
  );
}
